import clsx from 'clsx';
import React from 'react';
import {useSelector} from 'react-redux';
import {Link, NavLink} from 'react-router-dom';
import {useAuth0} from '../../contexts/auth0-context';
import {getPortalInfo} from '../../shared/utils';
import PartnerBadge from '../PartnerBadge/PartnerBadge';
import './Header.module.scss';
import classes from './Header.module.scss';

export default function Header() {
    const { isLoading, user, loginWithRedirect, logout } = useAuth0();
    const region = useSelector(state => state.ui.region);

    const getRegionIcon = () => {
        if (region === 'italy') {
            return <span className={classes.RegionIcon} role="img" title="Italian rules" aria-label="Italian rules">🇮🇹</span>;
        }

        return <span className={`${classes.RegionIcon} ${classes.WorldIcon}`} title="World rules" aria-label="World rules">
            <i className="fas fa-globe" />
        </span>;
    };

    return (
        <header>
            <nav className={clsx('navbar has-shadow is-spaced is-fixed-top', classes.Nav)}>
                <div className="navbar-start">
                    <div className="navbar-brand">
                        <Link to="/" className={clsx('navbar-item', classes.Logo)}>
                            <img alt="Company logo" src={getPortalInfo().headerLogo} />
                        </Link>
                    </div>

                    <div className="navbar-item" />

                    {/*<NavLink activeClassName="is-active" to="/promotions" className="navbar-item">
                        Promotions
                    </NavLink>*/}

                    <div className="navbar-item has-dropdown is-hoverable">
                        <NavLink activeClassName="is-active" to="/presentation/presentation-en" className="navbar-link">
                            Presentations
                        </NavLink>
                        <div className="navbar-dropdown">
                            <NavLink activeClassName="is-active" to="/presentation/presentation-en" className="navbar-item">
                                Presentation (EN)
                            </NavLink>
                            <NavLink activeClassName="is-active" to="/presentation/presentation-fr" className="navbar-item">
                                Presentation (FR)
                            </NavLink>
                            <NavLink activeClassName="is-active" to="/presentation/presentation-it" className="navbar-item">
                                Presentation (IT)
                            </NavLink>
                            <hr className="navbar-divider" />
                            <NavLink activeClassName="is-active" to="/presentation/case-studies-en" className="navbar-item">
                                Case Studies (EN)
                            </NavLink>
                            <NavLink activeClassName="is-active" to="/presentation/case-studies-fr" className="navbar-item">
                                Case Studies (FR)
                            </NavLink>
                            <NavLink activeClassName="is-active" to="/presentation/case-studies-it" className="navbar-item">
                                Case Studies (IT)
                            </NavLink>
                            <hr className="navbar-divider" />
                            <a href="https://drive.google.com/file/d/1mSsBleGGkNlyP8ww0QR9NYKOV9SnY8F8/view" className="navbar-item" target="_blank" rel="noopener noreferrer">
                                Flyer (EN)
                            </a>
                            <a href="https://drive.google.com/file/d/1gFyzukEPTo91fLwKiKRBJg7QtWJlCXyA/view" className="navbar-item" target="_blank" rel="noopener noreferrer">
                                Flyer (FR)
                            </a>
                            <a href="https://drive.google.com/file/d/1VmuI79zJItcPC8Q8CBG0rKYbHIRfEWBm/view" className="navbar-item" target="_blank" rel="noopener noreferrer">
                                Flyer (IT)
                            </a>
                            <hr className="navbar-divider" />
                            <a href="https://docs.google.com/spreadsheets/d/1INbx0lfSMOWX2JiJILuXrr1cIfGy5YCVYnPe59PVbNU"
                               className="navbar-item" target="_blank" rel="noopener noreferrer">
                                Qualification Questionnaire (EN)
                            </a>
                            <a href="https://docs.google.com/spreadsheets/d/1RhIiPOFPp_WkOSlbiBBix_Q2P6soPKuty6itWTTtGuU"
                               className="navbar-item" target="_blank" rel="noopener noreferrer">
                                Qualification Questionnaire (FR)
                            </a>
                        </div>
                    </div>

                    <NavLink activeClassName="is-active" to={`${region ? '/listing/aida' : '/'}`}
                             className="navbar-item">
                        Pricing
                    </NavLink>

                    <NavLink activeClassName="is-active" to="/order" className="navbar-item">
                        Order form
                    </NavLink>

                    <NavLink activeClassName="is-active" to="/customers" className="navbar-item">
                        Customers
                    </NavLink>

                    <div className="navbar-item has-dropdown is-hoverable">
                        <span className="navbar-link">
                            Support
                        </span>
                        <div className="navbar-dropdown">
                            <NavLink activeClassName="is-active" to="/renewals" className="navbar-item">
                                Contract renewals/upgrades
                            </NavLink>
                            <a href="https://doc.aidacloud.com" className="navbar-item" target="_blank"
                               rel="noopener noreferrer">
                                AIDA Docs
                            </a>
                            <a href="https://www.aidacloud.com/en/support/contacts" className="navbar-item"
                               target="_blank"
                               rel="noopener noreferrer">
                                Contact form
                            </a>
                        </div>
                    </div>
                </div>

                <div className="navbar-end">
                    {!isLoading && !user && (
                        <button onClick={loginWithRedirect} className="navbar-item">
                            Login
                        </button>
                    )}

                    {!isLoading && user && (
                        <>
                            <span className="navbar-item is-size-7" style={{ marginRight: '12px' }}>
                                <span className={classes.Username}>
                                    {user.name}
                                    {getRegionIcon()}
                                </span>
                                <PartnerBadge />
                            </span>
                            <button
                                onClick={() => logout({ returnTo: window.location.origin })}
                                className="button is-small"
                            >
                                Logout
                            </button>
                        </>
                    )}
                </div>
            </nav>
        </header>
    );
}
